import { useState } from 'react';
import { useAuth } from '../auth/AuthContext';
import { getDisplayName } from '../services/profileService';

export const UserAvatar = ({ className = '' }: { className?: string }) => {
  const { avatarUrl, user } = useAuth();
  const [failedUrl, setFailedUrl] = useState<string>();
  const displayName = getDisplayName(user);
  const initial = displayName.slice(0, 1).toLocaleUpperCase('pt-BR') || 'L';
  const visibleUrl = avatarUrl && failedUrl !== avatarUrl ? avatarUrl : null;

  return (
    <span className={`user-avatar ${className}`.trim()} aria-hidden="true">
      {visibleUrl
        ? <img src={visibleUrl} alt="" onError={() => setFailedUrl(visibleUrl)} />
        : <span>{initial}</span>}
    </span>
  );
};
